<template>
  <!-- <BreadCrumb PageTitle="Register" /> -->
  <TicketPayoutContent />
</template>

<script lang="ts">
import { onMounted,defineComponent } from "vue";
import stateStore from "../../utils/store";

//import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TicketPayoutContent from "../../components/Public/Ticket/TicketPayoutContent.vue";

export default defineComponent({
  name: "TicketPayoutPage",
  components: {
    //BreadCrumb,
    TicketPayoutContent,
  },
  setup(){
        const stateStoreInstance = stateStore;
        document.body.classList.remove("sidebar-show");
        document.body.classList.add("sidebar-hide");        
        onMounted(() => {
          stateStoreInstance.show = false;
        });
       return {stateStoreInstance};
  }
});
</script>